export class FetchUserTopUpPaymentsAction {
  static readonly type = '[Payment] Fetch User Top Up Payments';

  constructor() {
  }
}
